<template>
  <base-container>
    <ArtisanGrid
      metaKey="SysAppInfo"
      @setAppPermission="setPermission"
    ></ArtisanGrid>
    <artisan-dialog
      ref="dialog"
      :title="title"
      width="70%"
      height="70%"
      :visible.sync="isShow"
      v-loading="isLoading"
    >
      <div class="margin12">
        <el-button
          type="primary"
          size="mini"
          icon="el-icon-check"
          @click="allCheck"
        >
          全选
        </el-button>

        <el-button
          type="primary"
          size="mini"
          icon="el-icon-close"
          @click="allCancelCheck"
        >
          全不选
        </el-button>
      </div>
      <el-collapse isExpand class="margin-h12" v-model="activeNames">
        <el-collapse-item
          v-for="(item, index) in data.filter((c) => !c.apiGroup)"
          :key="index"
          :title="item.name"
          :name="item.code"
        >
          <template #title>
            <div class="margin-h12" v-text="item.name"></div>
          </template>
          <div class="margin-h12">
            <el-checkbox
              v-for="(iitem, index) in data.filter(
                (c) => c.apiGroup == item.code
              )"
              :key="index"
              v-model="iitem.isCheck"
              >{{ iitem.name }}</el-checkbox
            >
          </div>
        </el-collapse-item>
      </el-collapse>
      <template #footer>
        <el-button type="primary" size="mini" @click="setAppPermission"
          >确认授权</el-button
        >
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { list } from "@/api/sys/api";
import { getPermission, setPermission } from "@/api/sys/app";
export default {
  data() {
    return {
      isShow: false,
      isLoading: false,
      row: "",
      data: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      activeNames: [],
    };
  },
  computed: {
    title() {
      let title = "应用权限设置";
      if (this.row) title = this.row.name + "--应用权限设置";
      return title;
    },
  },
  methods: {
    allCheck() {
      this.data.forEach((c) => (c.isCheck = true));
    },
    allCancelCheck() {
      this.data.forEach((c) => (c.isCheck = false));
    },
    setPermission(row) {
      this.row = row;
      this.data = [];
      this.isShow = true;
      this.isLoading = true;
      list({
        orderBy: "id",
        isDesc: false,
        filterParams: [
          {
            name: "isValid",
            value: true,
          },
        ],
      })
        .then((res) => {
          let data = res.data.data;
          data.forEach((c) => (c.isCheck = false));
          this.data = data;
          return getPermission(row.id);
        })
        .then((res) => {
          let checkIds = res.data.data;
          this.data.forEach((c) => {
            if (checkIds.indexOf(parseInt(c.id)) >= 0) {
              c.isCheck = true;
            }
          });
          this.activeNames = this.data.filter(c=>!c.apiGroup).map((c) => c.code);
          this.isLoading = false;
        });
    },
    setAppPermission() {
      this.$refs.dialog.confirm({ msg: "确认授权？" }).then(() => {
        let ids = this.data.filter((c) => c.isCheck).map((c) => c.id);
        this.isShow = false;
        setPermission(this.row.id, ids.join(",")).then((res) => {
          this.$message({
            message: "授权成功！",
            type: "success",
          });
        });
      });
    },
  },
};
</script>

<style></style>
